<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
import Vue from "vue";
import commonObj from "./services/common.js";
import VueRouter from "vue-router";
import { Data } from "@syncfusion/ej2-grids";
// 测试

Vue.use(VueRouter);

var common = new commonObj();

export default {
  name: "app",
  mounted: function () {
    var self = this;
    var authToken = common.getAuthToken();
    //Here check if the user is logged in or not.
    if (!authToken) {
      window.location.href = "#/login";
    } else {
      if (common.getLanguage() == null || common.getLanguage() == undefined) {
        common.setLanguage("EN");
      }
      if (
        common.getLocalizedData() == null ||
        common.getLocalizedData() == undefined
      ) {
        common.startLoading();
        self.$store
          .dispatch("localizationStore/getWordList", {
            LanguageCode: common.getLanguage(),
          })
          .then((localizationResponse) => {
            common.setLocalizedData(JSON.stringify(localizationResponse.data));
            if (common.getIsClient()) {
              window.location.href = "#/new-order";
              window.location.reload();
            } else {
              window.location.reload();
            }
            common.stopLoading();
          });
      } else {
        if (common.getIsClient()) {
          this.$router.push({ name: "new-order" });
        }
      }
    }
    $("body").tooltip({
      selector: ".input_tooltip",
    });
  },
};
</script>

<style>
@import "../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../node_modules/@syncfusion/ej2-icons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../node_modules/@syncfusion/ej2-popups/styles/material.css";
@import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-navigations/styles/material.css";
@import "../node_modules/@syncfusion/ej2-layouts/styles/material.css";
@import "../node_modules/@syncfusion/ej2-grids/styles/material.css";
@import "../node_modules/@syncfusion/ej2-lists/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-calendars/styles/material.css";
@import "../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";
</style>
